import { Catalog, CatalogSourceMeta, Product, Bundle, PriceRules, SKU, sku } from '../canonical';
import { CatalogProvider } from '../provider';

export interface SerializedCatalog {
  schemaVersion: '1.0';
  sourceMeta: CatalogSourceMeta;
  products: Array<Product & { key: string }>;
  bundles: Array<Bundle & { key: string }>;
  priceRules: PriceRules;
}

export class MasterRoseAdapter implements CatalogProvider {
  readonly name = 'master-rose' as const;
  constructor(private readonly json: SerializedCatalog) {}

  async load(): Promise<Catalog> {
    const products = new Map<SKU, Product>();
    for (const p of this.json.products) {
      const { key, ...rest } = p;
      products.set(sku(key), rest as Product);
    }
    const bundles = new Map<SKU, Bundle>();
    for (const b of this.json.bundles) {
      const { key, ...rest } = b;
      bundles.set(sku(key), rest as Bundle);
    }
    return {
      schemaVersion: this.json.schemaVersion,
      sourceMeta: this.json.sourceMeta,
      products,
      bundles,
      priceRules: this.json.priceRules,
    };
  }
}
